<template>
  <div data-testid="shop-order-summary" class="border-l border-subtle bg-surface-elevation-1 p-8">
    <h3 class="mb-4 txt-headline-s">{{ $t('FestivalShop.checkout.orderSummary') }}</h3>

    <div class="space-y-3">
      <div
        v-for="(item, i) in cartItems"
        :key="item.productId + i"
        data-testid="shop-order-summary-item"
        :class="i === cartItems.length - 1 ? 'pb-3' : 'border-b border-main pb-3'"
      >
        <div class="flex justify-between gap-2">
          <div>
            <p class="txt-body-m-medium">{{ item.productName }}</p>
            <p v-if="item.variantName && !DEFAULT_VARIANT_NAMES.includes(item.variantName)" class="txt-body-s text-main">
              {{ item.variantName }}
            </p>
            <p class="txt-body-s text-subtle">{{ $t('FestivalShop.checkout.items', { count: item.count }) }}</p>
          </div>
          <p class="txt-body-s-medium whitespace-pre">{{ formatPrice(item.price * item.count, locale) }}</p>
        </div>
      </div>
    </div>

    <div data-testid="shop-order-summary-total" class="mt-4 border-t border-main pt-4">
      <div class="flex justify-between txt-headline-s">
        <span>{{ $t('FestivalShop.checkout.totalExclVat') }}</span>
        <span data-testid="shop-summary-total" class="whitespace-pre">{{ formatPrice(cartTotal, locale) }}</span>
      </div>
    </div>

    <div class="mt-4 rounded-lg p-4">
      <div class="flex items-start gap-2">
        <svg class="mt-0.5 h-5 w-5 shrink-0 text-subtle" fill="currentColor" viewBox="0 0 20 20">
          <path
            fill-rule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
            clip-rule="evenodd"
          />
        </svg>
        <p class="txt-body-s text-subtle">
          {{ $t('FestivalShop.checkout.invoiceInfo') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { inject } from 'vue'

import { FestivalShopCartKey } from '@/composables/useFestivalShopCart'
import { useLocaleStore } from '@/stores'

import { formatPrice } from './helpers'

const DEFAULT_VARIANT_NAMES = ['Default', 'Standard']

const festivalShopCart = inject(FestivalShopCartKey)
if (!festivalShopCart) {
  throw new Error('FestivalShopCart not provided')
}

const { cartItems, cartTotal } = festivalShopCart
const { locale } = storeToRefs(useLocaleStore())
</script>
